import React from 'react';

const Scrollbar = () => {
    // Scroll-to-top button removed
    return null;
}

export default Scrollbar;
